/* eslint-disable react/display-name */
import React from "react";

import { Button } from "@amzn/awsui-components-react";

import { formatDate } from "../../../utils";

export const COLUMN_DEFINITIONS = (history, eventStatus) => {
  let defs = [
    {
      id: "id",
      header: () => "ID",
      cell: item => item.id,
      minWidth: "100px",
      allowLineWrap: true
    },
    {
      id: "partnerId",
      header: () => "Partner ID",
      cell: item => item.partner.id,
      minWidth: "180px",
      allowLineWrap: true
    },
    {
      id: "date",
      header: () => "Date",
      cell: item => (
        <Button variant="link" onClick={() => history.push(`/event/${item.id}`)}>
          {formatDate(item.date)}
        </Button>
      ),
      minWidth: "150px",
      allowLineWrap: true
    },
    {
      id: "owner",
      header: () => "Event Owner",
      cell: item => `${item.user.firstName} ${item.user.lastName}`,
      minWidth: "120px",
      allowLineWrap: true
    },
    {
      id: "geo",
      header: () => "Geo",
      cell: item => item.geo,
      minWidth: "55px",
      allowLineWrap: true
    },
    {
      id: "topic",
      header: () => "Topic",
      cell: item => item.topic,
      minWidth: "75px",
      allowLineWrap: true
    }
  ];

  if (eventStatus === "Complete") {
    defs.push({
      id: "csat",
      header: () => "CSAT Score",
      cell: item => (item.csat.score ? item.csat.score : "-"),
      minWidth: "50px"
    });
  }

  return defs;
};

export const SORTABLE_COLUMNS = [
  { id: "date", field: "date" },
  { id: "owner", field: "eventOwner" },
  { id: "geo", field: "geo" },
  { id: "topic", field: "topic" },
  {
    id: "csat",
    comparator: (item1, item2) => {
      if (item1.csat.score === item2.csat.score) return 0;
      else return item1.csat.score > item2.csat.score ? 1 : -1;
    }
  }
];

export const CONTENT_SELECTOR_OPTIONS = [
  {
    label: "Table settings",
    options: [
      { id: "id", label: "ID", editable: false, visible: false },
      { id: "partnerId", label: "Partner ID", editable: false, visible: false },
      { id: "date", label: "Date", editable: true, visible: true },
      { id: "owner", label: "Event Owner", editable: true, visible: true },
      { id: "geo", label: "Geo", editable: true, visible: true },
      { id: "topic", label: "Topic", editable: true, visible: true },
      {
        id: "deliveryMethod",
        label: "Delivery Method",
        editable: true,
        visible: false
      },
      { id: "csat", label: "CSAT Score", editable: true, visible: true }
    ]
  }
];

export const PAGE_SELECTOR_OPTIONS = [
  { value: 10, label: "10" },
  { value: 30, label: "30" },
  { value: 50, label: "50" }
];
